import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { FiscalYearAction, FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { ProvinceAction, ProvinceGetter } from '@/store/province/province.module';
import { Province } from '@/store/province/province.model';
import VueSelect from 'vue-select';
import DoneTableComponent from '@/components/project/close/doneTable/DoneTable.vue';
import CompleteTableComponent from '@/components/project/close/completeTable/CompleteTable.vue';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'CloseProjectPage',
  components: {
    VueSelect,
    DoneTableComponent,
    CompleteTableComponent,
    LoadingComponent,
  },
  setup: () => {
    const store = useStore();
    const isLoading = computed(() => store.getters[ProvinceGetter.STATUS] === 'init' || store.getters[ProvinceGetter.STATUS] === 'loading');
    const selectedFiscalYear = ref<FiscalYear | null>();
    const fiscalYears = computed<FiscalYear[]>(() => (store.getters[FiscalYearGetter.ALL] as FiscalYear[]).filter(m => m.status <= 0));
    const selectedProvince = ref<Province | null>();
    const provinces = computed<Province[]>(() => {
      const all = store.getters[ProvinceGetter.ALL] as Province[];
      return all.filter(m => m.iso !== 'TH-10');
    });

    onMounted(() => {
      store.dispatch(FiscalYearAction.FETCH)
        .then(() => {
          selectedFiscalYear.value = fiscalYears.value[0];
          store.dispatch(ProvinceAction.FETCH)
            .then(() => selectedProvince.value = provinces.value[0]);
        });
    });

    const fiscalYearChange = () => {
      selectedProvince.value = provinces.value[0];
    };

    return {
      fiscalYears,
      selectedFiscalYear,
      provinces,
      selectedProvince,
      isLoading,
      fiscalYearChange,
    };
  },
});
